<div fxLayout="row wrap" fxLayoutAlign="end center" ngClass.xs="mb-3">
    <!-- <button mat-raised-button type="button" color="warn" (click)="deleteAddress()" class="mx-1"> 
        <mat-icon fxHide="false" fxHide.gt-xs="true">delete</mat-icon>
        <span fxShow="false" fxShow.gt-xs="true">Delete Address</span>
    </button>
	<button mat-raised-button type="button" color="primary" (click)="addAddress()">
        <mat-icon fxHide="false" fxHide.gt-xs="true">add</mat-icon>
        <span fxShow="false" fxShow.gt-xs="true">Add New Address</span>
    </button> -->
</div>
<!-- <mat-tab-group [selectedIndex]="selected" (selectedIndexChange)="onTabIndexChanged($event)" animationDuration="0"> -->
<mat-tab-group>
    <mat-tab>
        <ng-template mat-tab-label>
            <span>Mes coordonnées</span>

        </ng-template>
        <div class="o-hidden mt-4">
            <form [formGroup]="infoFormcoordonnees" (ngSubmit)="onInfoFormCoordonneesSubmit()" autocomplete="off">

                <div fxLayout="row wrap" class="flex-wrapper">
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Nom</mat-label>
                            <input matInput placeholder="Nom" formControlName="Nom" required>
                            <mat-error *ngIf="infoFormcoordonnees.controls.Nom.errors?.required">Nom obligatoire
                            </mat-error>
                            <!-- <mat-error *ngIf="infoFormcoordonnees.controls.Nom.hasError('maxNumberOfWordsExceeded')">Max number of words exceeded</mat-error>  -->
                        </mat-form-field>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Date de naissaince</mat-label>
                            <input matInput readonly placeholder="Date de naissaince" formControlName="DateNaissance"
                                [matDatepicker]="datePickerEnd" appMaskDate>
                            <mat-datepicker-toggle matSuffix [for]="datePickerEnd"></mat-datepicker-toggle>
                            <mat-datepicker #datePickerEnd></mat-datepicker>
                            <mat-error *ngIf="infoFormcoordonnees.controls.DateNaissance.errors?.required">Date de
                                naissaince obligatoire</mat-error>
                        </mat-form-field>
                    </div>
                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Phone</mat-label>
                            <input matInput placeholder="Enter your phone" formControlName="Phone" required>
                            <mat-error *ngIf="infoFormcoordonnees.controls.Phone.errors?.required">Phone obligatoire
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div fxFlex="100" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Quelques mots sur moi</mat-label>
                            <textarea matInput placeholder="Quelques mots sur moi" formControlName="Quelquesmots"
                                required rows="5"></textarea>
                            <mat-error *ngIf="infoFormcoordonnees.controls.Quelquesmots.errors?.required">Quelques mots
                                sur toi sont obligatoire</mat-error>
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Pays</mat-label>
                            <mat-select placeholder="Select country" formControlName="country" required>
                                 <mat-option *ngFor="let country of countries" [value]="country.code">
                                    {{country.name}}
                                </mat-option>
                            </mat-select>
                            <!-- <mat-error *ngIf="address.get('country')!.errors?.required">Country is required</mat-error> -->
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Ville</mat-label>
                            <input matInput placeholder="City" formControlName="city" required>
                            <!-- <mat-error *ngIf="address.get('city')!.errors?.required">City is required</mat-error>  -->
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Adresse</mat-label>
                            <input matInput placeholder="Place" formControlName="Place">
                            <mat-error *ngIf="infoFormcoordonnees.controls.Place.errors?.required">Place is required
                            </mat-error>
                        </mat-form-field>
                    </div>

                    <div fxFlex="100" fxFlex.gt-sm="50" class="px-3">
                        <mat-form-field appearance="outline" class="w-100">
                            <mat-label>Postal Code</mat-label>
                            <input matInput placeholder="Postal Code" formControlName="PostalCode">
                            <mat-error *ngIf="infoFormcoordonnees.controls.PostalCode.errors?.required">Postal Code is
                                required</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="text-center">
                        <button mat-raised-button color="primary" type="submit" class="w-100 uppercase"><span
                                class="px-3 uppercase">mettre à jour</span></button>
                    </div>
                </div>
            </form>
        </div>
    </mat-tab>
</mat-tab-group>

<!-- <div class="text-center">
  <button type="button" mat-raised-button color="primary" (click)="save()">
    <span class="px-3 uppercase">Save</span></button>
</div>  -->